import React from 'react';
import { Link } from 'react-router-dom';
import { StarIcon, MapPinIcon } from 'lucide-react';
const PropertyCard = ({
  property
}) => {
  const {
    id,
    title,
    location,
    images,
    pricePerNight,
    rating,
    reviewCount,
    propertyType
  } = property;
  return <Link to={`/property/${id}`} className="block bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-[1.02] hover:shadow-lg" data-id="element-582">
      <div className="relative h-48 sm:h-60" data-id="element-583">
        <img src={images[0]} alt={title} className="w-full h-full object-cover" data-id="element-584" />
        <span className="absolute top-3 left-3 bg-[#006D77] text-white text-xs px-2 py-1 rounded capitalize" data-id="element-585">
          {propertyType === 'bnb' ? 'Bed & Breakfast' : 'Farmstay'}
        </span>
      </div>
      <div className="p-4" data-id="element-586">
        <div className="flex justify-between items-start" data-id="element-587">
          <h3 className="font-semibold text-lg text-[#333333] line-clamp-1" data-id="element-588">
            {title}
          </h3>
          <div className="flex items-center" data-id="element-589">
            <StarIcon className="h-4 w-4 text-[#D4A017] fill-[#D4A017]" data-id="element-590" />
            <span className="ml-1 text-sm font-medium" data-id="element-591">{rating}</span>
            <span className="text-xs text-gray-500 ml-1" data-id="element-592">({reviewCount})</span>
          </div>
        </div>
        <div className="flex items-center mt-2 text-sm text-gray-500" data-id="element-593">
          <MapPinIcon className="h-4 w-4 mr-1" data-id="element-594" />
          <span className="line-clamp-1" data-id="element-595">{location}</span>
        </div>
        <div className="mt-4 flex justify-between items-center" data-id="element-596">
          <div data-id="element-597">
            <span className="font-bold text-[#333333]" data-id="element-598">${pricePerNight}</span>
            <span className="text-gray-500 text-sm" data-id="element-599"> / night</span>
          </div>
        </div>
      </div>
    </Link>;
};
export default PropertyCard;